// extracted by mini-css-extract-plugin
module.exports = {"taskProgress":"style_taskProgress__fa2sA","disabled":"style_disabled__3HibV"};